import { LoaderIcon } from 'lucide-react'

export function HydrateFallback() {
  return (
    <div className="container flex items-center justify-center gap-2 text-muted-foreground">
      <LoaderIcon className="size-4 animate-spin" />
      Chargement...
    </div>
  )
}
